"use strict";
/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomers = void 0;
exports.getCustomers = `query GetCustomers(
  $merchantId: String!
  $nextPageCursor: String
  $prevPageCursor: String
  $limit: Int!
  $loyaltyTierIds: [String]
  $retailerIds: [String]
  $lastPurchaseStartDate: String
  $lastPurchaseEndDate: String
  $query: String
  $showDeleted: Boolean
  $showWithoutLoyaltyTier: Boolean
  $hasPhoneNumber: Boolean
) {
  getCustomers(
    merchantId: $merchantId
    nextPageCursor: $nextPageCursor
    prevPageCursor: $prevPageCursor
    limit: $limit
    loyaltyTierIds: $loyaltyTierIds
    retailerIds: $retailerIds
    lastPurchaseStartDate: $lastPurchaseStartDate
    lastPurchaseEndDate: $lastPurchaseEndDate
    query: $query
    showDeleted: $showDeleted
    showWithoutLoyaltyTier: $showWithoutLoyaltyTier
    hasPhoneNumber: $hasPhoneNumber
  ) {
    customers {
      id
      address
      birthday
      canContactEmail
      canContactPhone
      cardId
      city
      country
      createDate
      customerType
      email
      firstName
      gender
      idType
      idNumber
      isActive
      isDeleted
      isTaxExempt
      lastName
      lastPurchaseDate
      loyaltyPoints
      loyaltyTierId
      loyaltyTierName
      memberGroup
      merchantId
      phone
      postalCode
      province
      retailerId
      retailerName
      status
      totalSpend
      updateDate
      __typename
    }
    pagination {
      nextPageCursor
      prevPageCursor
      limit
      __typename
    }
    __typename
  }
}
`;
//# sourceMappingURL=queries.js.map